<template>
    <span v-if="text" :class="className">
        <i :class="this.icon"></i> {{ text }}
    </span>
    <i v-else :class="className"></i>
</template>

<script>
export default {
    name : 'lego-icon',
    data () {
        return {};
    },
    props : {
        invert    : { type : Boolean, default : false },
        rounded   : { type : Boolean, default : false },
        hover     : { type : Boolean, default : false },
        circle    : { type : Boolean, default : false },
        icon      : { type : String, required : true },
        text      : { type : String, required : false },
        variation : { type : String, default : '1a' },
        color     : { type : String, default : 'primary' }
    },
    computed : {
        className () {
            const names = ['lego-icon'];
            if (!this.text) {
                names.push(this.icon);
            }
            names.push(`icon-effect-${this.variation}`);
            names.push(`icon-color-${this.color}`);
            if (this.invert) {
                names.push('icon-invert');
            }
            if (this.hover) {
                names.push('hover');
            }
            if (this.rounded) {
                names.push('icon-rounded');
            }
            if (this.circle) {
                names.push('icon-circle');
            }
            return names;
        }
    },
    methods : {}
};
</script>
